import { styled } from '@robocorp/theme';

export const HideFromMobile = styled.div<{ breakpoint?: number }>`
  @media (max-width: ${({ theme, breakpoint = 1 }) => theme.breakpoints[breakpoint]}) {
    display: none;
  }
`;
